/* TODO: optimilize this script to run faster */
const matchIataWithAirportName = (markers, routes) => {
  const matchedRoutes = routes.map(route => {
      for (let i = 0; i < markers.length; i++) {
        if(markers[i].iata === route.from) {
          route.fromId = markers[i].id
          route.fromName = markers[i].name
          route.fromCoor = {}
          route.fromCoor.lat = markers[i].x
          route.fromCoor.lng = markers[i].y
        }

        if(markers[i].iata === route.to) {
          route.toId = markers[i].id
          route.toName = markers[i].name
          route.toCoor = {}
          route.toCoor.lat = markers[i].x
          route.toCoor.lng = markers[i].y
        }
      }

    return route
  })

  return matchedRoutes
}

export default matchIataWithAirportName



// WEBPACK FOOTER //
// ./app/utils/matchIataWithAirportName.js